<template>
    <div class="search-results" v-if="data && data.length">
        <div
            v-for="(item, index) in data"
            class="search-results__item"
            :key="`search-${index}-${item.title}`"
        >
            <z-link
                :href="item.url"
                size="xl"
                class="search-results__link u-semi-bold"
                :underlined="false"
            >
                <span v-html="item.title"></span>
            </z-link>
            <p v-if="item.text" class="text-size-l u-bottom-margin--2xs" v-html="item.text"/>
            <z-date theme="simple" :from="item.date" />
        </div>
    </div>
</template>

<script setup>
defineProps({
    data: {
        type: Array,
        default: () => []
    }
})
</script>

<style lang="scss">
.search-results {
    &__link {
        @include margin-level(bottom, 2XS);
        display: inline-block;
    }

    &__item {
        & + & {
            @include margin-level(top, L);
            @include padding-level(top, L);
            border-top: 1px solid var(--colors-black-15);

        }

        .z-date{
            opacity: 0.8;
        }
    }
}
</style>
